import { useQuery } from '@tanstack/react-query';

import { getAlerts } from '../queries/getUnresolvedAlert.ts';

export const useAlerts = (territorySlug: string, queryParameters: Record<string, string>) => {
  return useQuery({
    queryKey: ['alert', territorySlug, queryParameters],
    queryFn: ({ signal }) => getAlerts(territorySlug, queryParameters, signal),
    enabled: territorySlug !== undefined && territorySlug !== '',
    retry: false,
    refetchInterval: 10000,
  });
};
